import type { OrderFrequency, PackagingPreference } from "@jti/fe-common";

import type { StickProductAggregations } from "../../../../containers/SticksProductDetailsContainer/types";
import type { SetAggregationType } from "../../hooks";

export const handleOtherPackagingTransition = (
  aggregation: StickProductAggregations | undefined,
  orderFrequency: OrderFrequency,
  newPackagingValue: PackagingPreference,
  setAggregation: SetAggregationType
) => {
  const predefinedSku = aggregation?.[orderFrequency]?.[newPackagingValue]?.sku;
  setAggregation({
    orderFrequency,
    packagingPreference: newPackagingValue,
    predefinedSku,
  });
};
